<div class="signup-layout">
    <div class="container-signup">
        <router-outlet></router-outlet>
    </div>
</div>